(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const moved = new Map();
  function move(node, destination, before = null) {
    if (!node || moved.has(node)) return;
    const marker = document.createComment('mobile original position');
    node.before(marker); moved.set(node, marker);
    destination.insertBefore(node, before);
  }
  function restore() {
    for (const [node, marker] of moved) { if (marker.parentNode) marker.replaceWith(node); }
    moved.clear();
    document.querySelectorAll('.cs-mobile-product-summary, .cs-mobile-product-price').forEach(n => n.remove());
  }
  function apply() {
    restore(); if (!mobile.matches) return;
    if (document.body.classList.contains('cs-template-collection')) {
      const grid = document.querySelector('.product-collection')?.closest('.shopify-section');
      if (grid) document.querySelectorAll('.cs-collection-description').forEach(box => {
        const section = box.closest('.shopify-section');
        if (section && section !== grid) move(section, grid.parentNode, grid.nextSibling);
      });
    }
    document.querySelectorAll('.main-product-template').forEach(section => {
      const product = section.querySelector('.main-product_info');
      const info = section.querySelector('.product__info-container');
      if (!product || !info) return;
      const summary = document.createElement('div'); summary.className = 'cs-mobile-product-summary';
      product.prepend(summary);
      ['.product__title'].forEach(selector => move(info.querySelector(selector), summary));
      const media = product.querySelector('.product__media-wrapper');
      const price = info.querySelector('.price-wrapper');
      if (media && price) {
        const pricePanel = document.createElement('div'); pricePanel.className = 'cs-mobile-product-price';
        media.after(pricePanel); move(price, pricePanel);
        const vat = document.createElement('span'); vat.className = 'cs-mobile-vat'; vat.textContent = 'inc. VAT';
        pricePanel.append(vat);
        move(info.querySelector('.product__sku'), pricePanel);
      }
      info.querySelectorAll('.product__text').forEach(text => {
        if (text.textContent.trim().toLowerCase() === 'price includes vat') text.classList.add('cs-mobile-hide-vat');
      });
    });
  }
  document.addEventListener('click', event => {
    if (!mobile.matches || !document.body.classList.contains('cs-template-collection')) return;
    const card = event.target.closest('.card-wrapper');
    const anchor = card?.querySelector('a[href*="/products/"]');
    if (!anchor || event.target.closest('button, .product-icons, .quick-add, .variant-option-color')) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation(); window.location.assign(anchor.href);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  mobile.addEventListener('change', apply);
  document.addEventListener('shopify:section:load', apply);
})();
